<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 表格 -->
      <p>評估列表：</p>
      <el-table ref="singleTable"
                :data="tableData"
                empty-text="暫無記錄"
                style="width: 100%"
                border>
        <el-table-column type="index"
                         label="序號"
                         width="60"></el-table-column>
        <el-table-column property="a"
                         label="題目">
          <template slot-scope="scope">
            <el-input v-model="scope.row.content" :maxlength="30"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="答案形式">
          <template slot-scope="scope">
            <!-- <el-select v-model="scope.row.contentType"
                       @change="changType"
                       placeholder="請選擇形式">
              <el-option label="單選"
                         value="0"></el-option>
              <el-option label="問答"
                         value="1"></el-option>
            </el-select> -->
            <el-select v-model="scope.row.contentType"
                       placeholder="請選擇形式">
              <el-option label="單選"
                         value="0"></el-option>
              <el-option label="問答"
                         value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="選項A">
          <template slot-scope="scope">
            <el-input v-model="scope.row.optionA" :disabled="scope.row.contentType == '1'?true:false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="選項B">
          <template slot-scope="scope">
            <el-input v-model="scope.row.optionB" :disabled="scope.row.contentType == '1'?true:false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="選項C">
          <template slot-scope="scope">
            <el-input v-model="scope.row.optionC" :disabled="scope.row.contentType == '1'?true:false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="選項D">
          <template slot-scope="scope">
            <el-input v-model="scope.row.optionD" :disabled="scope.row.contentType == '1'?true:false"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="100">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="warning"
                       @click="del(scope.$index)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="margin-top: 10px;"
                 icon="el-icon-plus"
                 @click="addTopic">新增題目</el-button>
      <div style="margin-top: 10px;text-align: center;">
        <el-button type="primary"
                   @click="submit">提交</el-button>
      </div>
      <el-button class="get-back"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [
        {
          optionA: '',
          optionB: '',
          optionC: '',
          optionD: '',
          content: '',
          contentType: '0'
        }
      ]
    };
  },
  mounted () {
    $('#pageHead').text('反饋模板');
  },
  methods: {
    del (index) {
      this.tableData.splice(index, 1);
    },
    addTopic () {
      this.tableData.push({
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        content: '',
        contentType: '0'
      });
    },
    submit () {
      let table = this.tableData;
      for (var i = 0; i < table.length; i++) {
        let item = table[i];
        if (item.content === '') {
          this.$message({
            type: 'warning',
            message: `請填寫第${i + 1}題的題目`
          });
          return
        }
        if (item.contentType == 0 && item.optionA === '' && item.optionB === '' && item.optionC === '' && item.optionD === '') {
          this.$message({
            type: 'warning',
            message: `請填寫第${i + 1}題的選項`
          });
          return
        }
      }
      console.log(table);
      this.pageLoading = true
      this.axios({
        method: 'post',
        params: {
          manModelZevaluaJson: JSON.stringify(table)
        },
        url: '/manage/addManModelZevalua'
      }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
        }
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    changType (e) {
      if (e == 1) {
        let arr = this.tableData.filter(item => {
          return item.contentType == 1;
        })
        if (arr.length > 1) {
          this.$message({
            type: 'warning',
            message: '問答題默認使用第一個'
          });
        }
      }

    }
  }, 
  created () {
    this.pageLoading = true
    this.axios.get("/manage/getManModelZevalua").then(res => {
      if (res) {
        let arr = [];
        res.result.forEach(item => {
          arr.push({
            optionA: item.optionA || '',
            optionB: item.optionB || '',
            optionC: item.optionC || '',
            optionD: item.optionD || '',
            content: item.content,
            contentType: item.contentType + ''
          })
        })
        this.tableData = arr;
      }
      this.pageLoading = false
    }).catch(() => {
      this.pageLoading = false
    })
  }
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
.get-back {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
